import React from 'react';
import { useCategoriesViewModel } from '../../viewmodels/useCategoriesViewModel';
import { CategoryMenuConfig } from '../../themes/themeTypes';
import CategoryMenuFlat from './CategoryMenuFlat';
import CategoryMenuDropdown from './CategoryMenuDropdown';
import CategoryMenuMega from './CategoryMenuMega';

interface CategoryMenuProps {
  config?: CategoryMenuConfig;
  className?: string;
  navLinkClassName?: string;
}

const DEFAULT_CONFIG: CategoryMenuConfig = {
  style: 'dropdown',
  enabled: true,
  showImages: false,
  showDescriptions: false,
  position: 'in-nav',
  label: 'Products',
};

const CategoryMenu: React.FC<CategoryMenuProps> = ({ config, className, navLinkClassName }) => {
  const menuConfig = { ...DEFAULT_CONFIG, ...config };
  const { topLevelCategories, isLoading } = useCategoriesViewModel();

  if (!menuConfig.enabled || isLoading || !topLevelCategories.length) {
    return null;
  }

  // Filter categories by allowedHandles if configured (for multi-tenant category scoping)
  const filteredCategories = menuConfig.allowedHandles?.length
    ? topLevelCategories.filter((cat) => menuConfig.allowedHandles!.includes(cat.handle))
    : topLevelCategories;

  if (!filteredCategories.length) {
    return null;
  }

  switch (menuConfig.style) {
    case 'flat':
      return <CategoryMenuFlat categories={filteredCategories} className={className} navLinkClassName={navLinkClassName} />;
    case 'mega':
      return <CategoryMenuMega categories={filteredCategories} config={menuConfig} className={className} navLinkClassName={navLinkClassName} />;
    case 'dropdown':
    default:
      return <CategoryMenuDropdown categories={filteredCategories} config={menuConfig} className={className} navLinkClassName={navLinkClassName} />;
  }
};

export default CategoryMenu;
